export default __webpack_public_path__ + "static/media/group-5699.42cb6d3d.svg";